// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"cf120060","430":"4a6c0c25","453":"56cd8fe8","565":"cdc2c05f","568":"5d712bbf","772":"753e15c4","879":"1550204e"}[chunkId] + ".chunk.js";
};